import { render } from "./FilmReviewedIndicator.vue?vue&type=template&id=0274e97e&scoped=true"
import script from "./FilmReviewedIndicator.vue?vue&type=script&lang=js"
export * from "./FilmReviewedIndicator.vue?vue&type=script&lang=js"

import "./FilmReviewedIndicator.vue?vue&type=style&index=0&id=0274e97e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0274e97e"]])

export default __exports__